<template>
  <div class="animated fadeIn col-md-12">
    <Search
      ref="taskAdminSearch"
      :url="url"
      :hiddenFields="hiddenFields"
      :allowFields="$lang.serachTackFields"
      :title="$lang.all_tasks"
      :remove_item="remove_item"
      :toggleable="true"
      addModalSize="lg"
      removeModalSize="xl"
      :filterCatch="true"
      :dynamicButtons="buttons"
      :defaultViewCount="50"
      :primaryKey="`code`"
      :openNewTab="false"
      routeName="editTaskAdmin"
      @getPermisson="getPermissions"
      :visibleAdd="isAdmin(permissions, ['admin'])"
    >
      <template slot="addModal" slot-scope="search">
        <AddTask @modal-end-up="search.close" @getData="getItems" />
      </template>
    </Search>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddTask from "./addTask";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  name: "search-task",
  inject: ["taskRepository"],
  components: {
    Search,
    AddTask,
  },
  data() {
    return {
      hiddenFields: [
        "created_by",
        "created_at",
        "reference",
        "show_at",
        "description",
        "action",
      ],
      isLoading: false,
      buttons: [
        {
          id: "0",
          name: "edit",
        },
        {
          id: "1",
          name: "view",
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      permissions: [],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["resources", "all_task"]);
    },
  },
  methods: {
    isAdmin,
    generateApiUrl,
    getItems() {
      this.$refs.taskAdminSearch.getItems();
    },
    async remove_item(item) {
      try {
        let response = await this.taskRepository.delete(item.code);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    getPermissions(permissions) {
      this.permissions = permissions;
    },
  },
};
</script>
